/**
 * this file combines all actions creators
 *
 * Created by Paul on 7/5/19
 */

import * as RouterActions from './routerActions'
import * as FundsSummaryActions from './fundsSummaryActions'

import * as ComponentActions from './componentActions'
import * as PortfolioActions from './portfolioActions'
import * as InvestmentActions from './investmentActions'
import * as TransactionActions from './transactionActions'
import * as NewsActions from './newsActions'
import * as ProfileActions from './profileActions'
import * as FundActions from './fundActions'
import * as DocumentsActions from './documentsActions'
import * as BillingActions from './billingActions'
import * as ReferralActions from './referralActions'
import * as ReportActions from './reportActions'

export const ActionCreator = Object.assign({},

    // add all action creators here
    RouterActions,
    FundsSummaryActions,
    ComponentActions,
    PortfolioActions,
    InvestmentActions,
    TransactionActions,
    NewsActions,
    ProfileActions,
    FundActions,
    DocumentsActions,
    BillingActions,
    ReferralActions,
    ReportActions
)



// WEBPACK FOOTER //
// ./src/actions/index.js